
export const mapStatusToLabel: Record<string, string> = {
  WAITING: "รอดำเนินการ",
  APPROVED: "อนุมัติแล้ว",
  REJECTED: "ไม่อนุมัติ",
  NO_PROBLEM_REPORT: "ไม่ได้รายงานปัญหา"
};

export const mapStatusToColor: Record<string, string> = {
  WAITING: "text-gray-500",
  APPROVED: "text-green-600",
  REJECTED: "text-red-600",
  NO_PROBLEM_REPORT: "text-blue-600"
};
